import { interpret } from 'xstate'
import authMachine from '../services/auth/machine'

export default defineNuxtPlugin((nuxtApp) => {
  const auth = useAuth()

  const authService = interpret(authMachine).onTransition((state) => {
    auth.factor = state.value
    // state.children is service # https://xstate.js.org/docs/guides/communication.html#referencing-services
    const accountService = state.children.accountAuthMachine
    if (accountService) {
      accountService.onTransition((state) => (auth.accountStatus = state.value))
      authService.requestLogin = ({ accountInfo }) =>
        accountService.send({ type: 'LOG_IN', accountInfo })
      authService.requestLogout = () => {
        accountService.send({ type: 'LOG_OUT' })
      }
      authService.refreshToken = ({ accountInfo }) =>
        accountService.send({ type: 'REFRESH_TOKEN', accountInfo })
    }
  })
  authService.start()

  nuxtApp.provide('auth', authService)
})
